import { withAIOpsDomainPrefix } from '@atlassian/aiops-common';
import { URLBuilder } from '@atlassian/eoc-alert-common';
import { fetch } from '@atlassian/eoc-fetch';

import { type AlertGroupFeatureStateResponse } from '../types';

export const getGroupFeatureStatus = () => {
	const url = new URLBuilder(withAIOpsDomainPrefix('/v1/aiops/feature-state'))
		.withQueryParam('featureName', 'alert-grouping')
		.build();
	return fetch<AlertGroupFeatureStateResponse>(url, {
		exactUrl: true,
	});
};
